
import { Component, Vue, Watch } from "vue-property-decorator";
import config from "./config";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import Scan from "@/views/components/Scan/Scan.vue";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
// import { parseTime } from "@/utils";

@Component({
  name: "Form3",
  components: {
    YtoTable,
    Scan
  }
  // filters: {
  //   parseValue(value: any, prop: string) {
  //     if (value instanceof Date) {
  //       return parseTime(value);
  //     }
  //     return value;
  //   }
  // }
})
export default class extends Vue {
  @Watch("formmodel1", { deep: true })
  onChildChanged(val: string) {
    obj_ScanForWeighbridgeItem.sendFormDataToNet(val);
  }
  mounted() {
    try {
      obj_ScanForWeighbridgeItem.regist_errormsgcallback(this.errormsgcallback);
      obj_ScanForWeighbridgeItem.regist_updateformdata(
        this.updateformdatacallback
      );
      obj_ScanForWeighbridgeItem.sendFormDataToNet(this.formmodel1);
      obj_ScanForWeighbridgeItem.regist_datahistorycallback(
        this.datahistorycallback
      );

      this.InitIOStatus();
    } catch (error) {
      console.log("地磅称重1Vue出现异常:" + error);
    }

    // //初始化设备状态
    // this.deviceItems = [];
    // for (let index = 1; index <= 12; index++) {
    //   this.deviceItems.push({
    //     name: "设备" + index.toString(),
    //     title: index.toString(),
    //     status: "defult",
    //   });
    // }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }
  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  public datahistorycallback(datahistory) {
    this.showPrintedList = datahistory;
  }
  public updateformdatacallback(data) {
    if (this.formmodel1.input_IoStatus != data.input_IoStatus) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_TareWeight != data.input_TareWeight) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_SuttleWeight != data.input_SuttleWeight) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_LoadingWeight != data.input_LoadingWeight) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_UnloadingWeight != data.input_UnloadingWeight) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_WeightDate != data.input_WeightDate) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_NetWeight != data.input_NetWeight) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_LineCode != data.input_LineCode) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_LineName != data.input_LineName) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_CQ != data.input_CQ) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_SourceOrgCode != data.input_SourceOrgCode) {
      this.formmodel1 = data;
      return;
    }
    if (
      this.formmodel1.input_SourceOrgCodeName != data.input_SourceOrgCodeName
    ) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_CarNumber != data.input_CarNumber) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_CarNumberExtend != data.input_CarNumberExtend) {
      this.formmodel1 = data;
      return;
    }
    if (this.formmodel1.input_RoughWeight != data.input_RoughWeight) {
      this.formmodel1 = data;
      return;
    }
  }
  //错误消息回调显示方法
  public errormsgcallback(data) {
    this.errormessage = data;
  }
  public InitIOStatus() {
    var statusList = obj_ScanForWeighbridgeItem.initIoStatus();
    var statusListObj = JSON.parse(statusList);
    this.options = statusListObj.map(item => {
      return { value: `${item.Key}`, label: `${item.Value}` };
    });
    if (this.options.length > 0) {
      this.formmodel1.input_IoStatus = this.options[0].value;
    }
  }
  private errormessage = "";
  private deviceItems: deviceItem[] = [];
  public ytoCode = "";
  //扫描区扫码
  private ytocodeget() {
    this.formmodel1.input_ScanCode = this.ytoCode.toUpperCase();
    obj_ScanForWeighbridgeItem.cQQueryFacade(this.formmodel1);
  }
  public carlabel = "";
  private config = config;

  private formmodel1: inputDataModel_WeighbridgeItem = {
    input_ScanCode: "",
    input_IoStatus: "",
    input_LineCode: "",
    input_LineName: "",
    input_CQ: "",
    input_SourceOrgCode: "",
    input_SourceOrgCodeName: "",
    input_CarNumber: "",
    input_CarNumberExtend: "",
    input_RoughWeight: "",
    input_TareWeight: "",
    input_SuttleWeight: "",
    input_LoadingWeight: "",
    input_UnloadingWeight: "",
    input_WeightDate: "",
    input_NetWeight: ""
  };
  public showPrintedList = [];

  public options = [
    {
      value: "",
      label: ""
    }
  ];
  public PrintAndUploadFunc() {
    obj_ScanForWeighbridgeItem.printAndUpload(this.formmodel1);
  }
  public UploadFunc() {
    obj_ScanForWeighbridgeItem.upload(this.formmodel1);
  }
  public ReweighFunc() {
    this.formmodel1.input_ScanCode = this.ytoCode.toUpperCase();
    obj_ScanForWeighbridgeItem.reweigh(this.formmodel1);
  }
}
